// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import TermsPage from "../pages/Terms/Terms";
const __wvcRoutePaths = ["/TermsPage", "/terms"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "about", "aboutpage", "architectureofknowledgepage", "area-51", "area51page", "black-holes", "blog", "blogpage", "contact", "contactpage", "cosmic-discoveries", "cosmicdestinycodepage", "cosmicdiscoveriespage", "create-your-universe", "createyouruniversepage", "critical-thinking-workshop", "criticalthinkingpage", "digital-immortality", "digital-immortality-dashboard", "digital-immortality-sign-in", "dinosaur-ages", "dinosaur-behavior", "dinosaur-biology", "dinosaur-discovery", "dinosaur-ecosystems", "dinosaur-extinction", "dinosaur-family-tree", "dinosaur-legacy", "dinosaur-species-explorer", "dinosauragespage", "dinosaurbehaviorpage", "dinosaurbiologypage", "dinosaurdiscoverypage", "dinosaurecosystemspage", "dinosaurextinctionpage", "dinosaurfamilytreepage", "dinosaurlegacypage", "dinosaurs", "dinosaurspage", "dinosaurspeciesexplorerpage", "eternalyoudashboardpage", "eternalyousigninpage", "fallacy-library", "fallacylibrarypage", "glossary-references", "glossaryandreferencespage", "home", "homepage", "human-ideas", "human-ideas-comparison", "human-ideas-critical-thinking", "human-ideas-ideologies", "human-ideas-revolutions", "human-ideas-thinkers", "human-ideas-timeline", "humanideascomparisonpage", "humanideascriticalthinkingpage", "humanideasideologiespage", "humanideaspage", "humanideasrevolutionspage", "humanideasthinkerspage", "humanideastimelinepage", "kardashev-scale", "kardashevscalepage", "knowledge-laboratory", "knowledgelaboratorypage", "large-hadron-collider", "largehadroncolliderpage", "logic-laboratory", "logiclaboratorypage", "multiverse-atlas", "multiverseatlaspage", "near-death-experiences", "neardeathexperiencespage", "origin-beyond", "originandbeyondpage", "philosophy-as-investigation", "philosophyasinvestigationpage", "post", "privacy-policy", "privacypolicypage", "quantum-lab", "quantumlabpage", "search", "shapeofrealitypage", "simulation-theory", "simulationtheorypage", "syntergence", "syntergencepage", "terms", "termspage", "the-222-effect", "the-alien-question", "the-architecture-of-knowledge", "the-cosmic-destiny-code", "the-intelligence-frontier", "the-shape-of-reality", "thealienquestionpage", "thedescentpage", "theeffect222page", "theeternalyoupage", "theintelligencefrontierpage", "transhumanism", "transhumanismpage", "what-happens-after-death", "what-if-universe", "what-is-consciousness", "whathappensafterdeathpage", "whatifuniversepage", "whatisconsciousnesspage", "where-did-we-come-from", "where-is-everything-going", "wheredidwecomefrompage", "whereiseverythinggoingpage", "your-future-self", "your-infinite-selves", "yourfutureselfpage", "yourinfiniteselvespage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<TermsPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<TermsPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
